<template>
  <bill-card :header="header" :rightBtns="rightBtns">
    <bill-bar
      id="cost-trend"
      :isHistogram="true"
      :showToolbox="showToolbox"
      :completionDate="completionDate"
      :splitLineShow="splitLineShow"
      :height="height"
      :seriesArr="seriesArrC"
      :loading="loading"
      :showLegend="showLegend"
      :chartSettings="chartSettings"
      :tooltipLabel="tooltipLabel"
      :currencySign="currencySign"
      :numerifyFormat="numerifyFormat"
      :isFormatNumber="isFormatNumber"
      :dateMode="dateMode" />
    <slot slot="header-right" name="header-right" />
  </bill-card>
</template>

<script>
import BillCard from '@Bill/components/BillCard'
import BillBar from '@Bill/components/BillBar'
import i18n from '@/locales'
import { currencyUnitMap } from '@/constants/currency'

export default {
  name: 'ConsumeCard',
  components: {
    BillCard,
    BillBar,
  },
  props: {
    header: Object,
    rightBtns: Array,
    height: {
      type: String,
      default: '300px',
    },
    showToolbox: {
      type: Boolean,
      default: true,
    },
    completionDate: {
      type: Boolean,
      default: true,
    },
    seriesArr: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    chartSettings: {
      type: Object,
      default: () => ({
        labelMap: {
          value: i18n.t('bill.actual_cost'),
          predict: i18n.t('bill.predict'),
        },
      }),
    },
    splitLineShow: {
      type: Boolean,
      default: false,
    },
    tooltipLabel: {
      type: String,
    },
    currencySign: {
      type: String,
      default: currencyUnitMap.CNY.sign,
    },
    numerifyFormat: {
      type: String,
    },
    showLegend: {
      type: Boolean,
      default: false,
    },
    isFormatNumber: {
      type: Boolean,
      default: true,
    },
    dateMode: {
    },
    dataType: String,
  },
  data () {
    return {
      predictExcelColumnMap: {
        [this.$t('bill.date')]: {
          field: 'time',
          callback: (value) => {
            return value.replace('TZ', '')
          },
        },
        [this.$t('bill.actual_cost')]: {
          field: 'value',
          callback: (value) => {
            return value ? `${this.currencySign} ${parseFloat(value).toFixed(2)}` : ''
          },
        },
        [this.$t('bill.predict')]: {
          field: 'predict',
          callback: (value) => {
            return value ? `${this.currencySign} ${parseFloat(value).toFixed(2)}` : ''
          },
        },
      },
    }
  },
  computed: {
    seriesArrC () {
      const newArr = this.seriesArr.map(val => {
        const time = val.time.replace('TZ', '')
        const ret = {
          ...val,
          time: this.$moment(time).format(this.timeFormat),
        }
        delete ret.isPredict
        return ret
      })
      return newArr
    },
    timeFormat () {
      if (this.dataType) {
        if (this.dataType.includes('month')) {
          return 'YYYY-MM'
        }
        if (this.dataType.includes('day')) {
          return 'MM-DD'
        }
      }
      return 'YYYY-MM-DD'
    },
  },
  methods: {
  },
}
</script>
